export default "data:image/svg+xml,fr.svg"